import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";

export default function StudioRentalConfirmation() {
    const [loader, setLoader] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [orders, setOrders] = useState([]);

    const getStudioRentalOrders = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/StudioRentalPending`);
            if (res.status === 200) {
                setOrders(res.data.data || []);
            } else {
                setOrders([]);
            }
        } catch (err) {
            console.log(err);
            setLoader(true);
        }
    };

    useEffect(() => {
        getStudioRentalOrders();
    }, []);

    useEffect(() => {
        const filtered = (orders || []).filter((item) =>
            (item.user_name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
            String(item.total_rupees || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
            String(item.total_doller || "").toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredData(filtered);
    }, [orders, searchQuery]);

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(0);
    };

    const indexOfLastItem = (currentPage + 1) * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected);
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(parseInt(e.target.value));
        setCurrentPage(0);
    };

    const confirmOrder = async (id) => {
        try {
            const result = await Swal.fire({
                text: "Approve this studio rental order?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#5000C0",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Confirm",
                cancelButtonText: "Cancel",
            });

            if (result.isConfirmed) {
                const res = await axios.put(`${process.env.REACT_APP_BACKEND_BASE_URL}/CashCollect/${id}`);
                if (res.status === 200) {
                    getStudioRentalOrders();
                    Swal.fire({
                        icon: "success",
                        title: "Order confirmed successfully",
                        timer: 1500,
                    });
                } else {
                    Swal.fire({
                        title: "Confirmation failed",
                        icon: "error",
                    });
                }
            }
        } catch (err) {
            console.error(err);
            setLoader(true);
        }
    };

    const rejectOrder = async (id) => {
        try {
            const result = await Swal.fire({
                title: "Reject this order?",
                text: "This action will delete the order permanently.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#5000C0",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, reject",
            });

            if (result.isConfirmed) {
                const res = await axios.delete(`${process.env.REACT_APP_BACKEND_BASE_URL}/deleteOrder/${id}`);
                if (res.status === 200) {
                    getStudioRentalOrders();
                    Swal.fire({
                        title: "Rejected",
                        text: "Order has been rejected.",
                        icon: "success",
                        timer: 1500,
                    });
                } else {
                    Swal.fire({
                        title: "Reject failed",
                        icon: "error",
                    });
                }
            }
        } catch (err) {
            console.error("Error rejecting order:", err);
            setLoader(true);
        }
    };

    if (loader) {
        return (
            <div className="page-wrapper page-settings">
                <div className="content">
                    <h5>Something went wrong while loading studio rental orders.</h5>
                </div>
            </div>
        );
    }

    return (
        <div className="page-wrapper page-settings">
            <div className="content">
                <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item active" aria-current="page">Studio Rental Confirmation</li>
                    </ol>
                </nav>

                <div className="content-page-header content-page-headersplit">
                    <h5>Studio Rental Confirmation</h5>
                </div>

                <div className="d-flex justify-content-between">
                    <div className="col-lg-4">
                        <div className="form-group">
                            <label>Search</label>
                            <input
                                id="search"
                                className="form-control"
                                type="text"
                                placeholder="Search customer or amount"
                                aria-label="Search Input"
                                value={searchQuery}
                                onChange={handleSearch}
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive">
                            <table className="table datatable">
                                <thead>
                                    <tr>
                                        <th>Index</th>
                                        <th>Name</th>
                                        <th>Date</th>
                                        <th>INR</th>
                                        <th>USD</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                {currentItems.length === 0 ? (
                                    <tr>
                                        <td colSpan="12">No studio rental pending orders</td>
                                    </tr>
                                ) : (
                                    currentItems.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{indexOfFirstItem + index + 1}</td>
                                            <td>{item.user_name || "-"}</td>
                                            <td>{new Date(item.date).toISOString().split("T")[0]}</td>
                                            <td>{item.total_rupees || 0}</td>
                                            <td>{item.total_doller || 0}</td>
                                            <td style={{ color: "red" }}>Pending</td>
                                            <td>
                                                <div className="table-actions d-flex">
                                                    <button
                                                        style={{ border: "none" }}
                                                        onClick={() => confirmOrder(item.id)}
                                                        className="delete-table me-2"
                                                        title="Confirm"
                                                    >
                                                        <i className="fa-solid fa-check"></i>
                                                    </button>
                                                    <button
                                                        style={{ border: "none" }}
                                                        onClick={() => rejectOrder(item.id)}
                                                        className="delete-table delll"
                                                        title="Reject"
                                                    >
                                                        <i className="fa-solid fa-xmark"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </table>
                        </div>
                    </div>
                </div>

                <nav className="mt-4 pagination justify-content-end gap-2">
                    <select
                        className="form-select"
                        style={{ width: "70px", padding: "0 13px" }}
                        value={itemsPerPage}
                        onChange={handleItemsPerPageChange}
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                    </select>
                    <ReactPaginate
                        className="pagination justify-content-center"
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        pageClassName={"page-link"}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        previousLinkClassName={"page-link"}
                        nextLinkClassName={"page-link"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                    />
                </nav>
            </div>
        </div>
    );
}
